/** Tags affichés pour les plateformes (catalogue / accès tenant). Indépendant de `module-tags.js` (même dossier). */
const TONE_BY_PLATFORM_TAG = Object.freeze({
  new: 'info',
  beta: 'warning',
  old: 'neutral',
  maintenance: 'destructive',
  ai: 'ai',
});

// The tags an admin can put on a platform. `ai` is left out: it came over from module-tags.js
// when the two were split, and no platform has ever carried it.
export const PLATFORM_TAGS = Object.freeze(['new', 'beta', 'maintenance', 'old']);

export function getPlatformTagTone(tag) {
  if (typeof tag !== 'string' || !tag) return 'neutral';
  return TONE_BY_PLATFORM_TAG[tag] || 'neutral';
}

export function getPlatformTagIcon(tag) {
  return tag === 'ai' ? 'ai' : null;
}
